import React from "react";
import styled from "styled-components";

interface Props {
  children: any;
}

const browserColor = "rgb(34,34,34)";

const Browser = styled.div`
  display: block;
  position: relative;
  border: 4px solid ${browserColor};
  width: 100%;
  max-width: 1440px;
  margin: 80px auto 20px;
  border-radius: 8px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
`;

const BrowserTab = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: row nowrap;
  position: absolute;
  width: calc(100% + 8px);
  height: 40px;
  top: -40px;
  left: -4px;
  background-color: ${browserColor};
  border: 4px solid ${browserColor};
  border-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 0 96.5% 0 8px;
`;

const Circle = styled.div`
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
`;

const FakeBrowser: React.FC<Props> = ({
  children,
}: Props): React.ReactElement => (
  <Browser>
    <BrowserTab>
      <Circle style={{ backgroundColor: "rgb(252,60,63)" }} />
      <Circle style={{ backgroundColor: "rgb(253,180,36)" }} />
      <Circle style={{ backgroundColor: "rgb(41,201,51)" }} />
    </BrowserTab>
    {children}
  </Browser>
);

export default FakeBrowser;
